/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import Layout from '../_ens/layout';
import BasePage from './BasePage';
import { Logout, AuthPage } from './modules/Auth';
import ErrorPage from './modules/Errors/ErrorPage';
import { getParentRoute } from './servics/CommonFunctions';
import UpdateTimeAppointment from '../app/modules/updateTimeAppointment/index';
import FrameBoard from './modules/Auth/pages/frameBoard';
import RejectAppointment from './modules/rejectAppointment';

// STAI 2 Components
import {
  ProjectSelection,
  STAI2GuestAccess,
  VideoCallSTAI2
} from './modules/STAI2';
import HomeRedirect from './components/HomeRedirect';

export function Routes() {
  const { isAuthorized, authState } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
      authState: auth
    }),
    shallowEqual
  );

  let redirectUrl = getParentRoute();

  // Debug log
  console.log('Routes - Auth state:', {
    isAuthorized,
    user: !!authState.user,
    authToken: !!authState.authToken,
    pathname: window.location.pathname
  });

  return (
    <Switch>
      <Route path={'/update-appointment-time/:token/:email'} component={UpdateTimeAppointment} />
      <Route path={'/reject-appointment/:token/:email'} component={RejectAppointment} />
      <Route path={'/frame-board'} component={FrameBoard} />

      {/* STAI 2 Routes - Accessibili senza autenticazione */}
      <Route path="/project-selection" component={ProjectSelection} />
      <Route path="/guest" component={STAI2GuestAccess} />

      <Route exact path="/flis" render={() => <Redirect to="/guest?id=3&h=1" />} />
      <Route exact path="/stai2" render={() => <Redirect to="/guest?id=2&h=1" />} />

      {/* STAI 2 Guest VideoCall - Permette agli ospiti di accedere alla VideoCall */}
      <Route path="/guest-call" component={VideoCallSTAI2} />

      {/* Test Route - Per testare direttamente ProjectSelection */}
      <Route path="/test-project-selection" component={ProjectSelection} />

      {/* Auth routes - specifici */}
      <Route path="/auth" component={AuthPage} />

      <Route path={redirectUrl + 'error'} component={ErrorPage} />
      <Route path={redirectUrl + 'logout'} component={Logout} />
      <Route
        path="/privacy-policy"
        component={() => {
          window.location.href =
            'https://www.ens.it/images/immagini/2019/05/Informativa_sulla_privacy.pdf';
          return null;
        }}
      />
      <Route
        path="/cokies"
        component={() => {
          window.location.href = 'https://www.ens.it/cookie-policy';
          return null;
        }}
      />
      <Route path={'/documentation'} component={ErrorPage} />

      {isAuthorized ? (
        /* User is authenticated - show main app */
        <Layout>
          <BasePage />
        </Layout>
      ) : (
        /* User is not authenticated - show project selection or redirect to auth */
        <Route exact path="/" component={HomeRedirect} />
      )}
    </Switch>
  );
}
